<template>
    <div class="d-flex justify-content-center flex-wrap">
        <div class="col-12 col-md-8 col-lg-4">
            <div class="text-center shadow p-4">
                <h4 class="text-third mb-4">
                    {{ $t('Auth.EmailConfirmationInProgress.progress') }}
                </h4>
                <span class="text-second">
                    <i class="fa-solid fa-envelope-open-text text-icon email_check"></i>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
    name: 'EmailConfirmationInProgress',
    computed: {
        ...mapGetters(['apiPath', 'omsApiKey']),
    },
    methods: {
        ...mapMutations(['setErrorFromServer']),
        confirm_email() {
            this.$http
                .post(`${this.apiPath}/email/confirm_email`, { token: this.$route.query.token }, {
                    headers: {
                        "x-api-key": this.omsApiKey
                    },
                })
                .then((res) => {
                    switch (res.data) {
                        case 'Request Expired':
                            this.$toast.error(this.$t('Auth.RequestExpired.expired'))
                            break;
                        default:
                        this.$toast.success(`${this.$t('Auth.EmailConfirmed.succeeded')}: <strong>${res.data}</strong> <p class="m-0">${this.$t('Auth.EmailConfirmed.thanks')}</p> <p>${this.$t('Auth.EmailConfirmed.login_now')}</p>`)
                        break;
                    }
                    this.$router.replace('/')
                })
                .catch((err) => {
                    this.setErrorFromServer(err.message)
                })
        }
    },
    created() {
        this.confirm_email()
    }
}
</script>